import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { debounce, throttle } from "lodash";
import { KeepAliveService } from "../../services/keep-alive.service";

@Component({
  selector: 'app-keep-alive',
  templateUrl: 'keep-alive.component.html',
  standalone: false
})
export class KeepAliveComponent implements OnInit {
  @Input() keepAliveUrl: string;

  imageUrl: SafeUrl;

  constructor(
    private keepAliveService: KeepAliveService,
    private sanitizer: DomSanitizer
  ) {
    this.keepAliveService.onPing.subscribe(this.onPing.bind(this));
  }

  private config = { rateLimiting: { debounceRequestSeconds: 15, throttleRequestMinutes: 15 } };

  ngOnInit() {
    this.onPing();
  }

  onPing() {
    this.debouncedOktaRefresh();
  }

  // debounce NEB refresh triggers to 15 seconds
  // subsequent requests received within this timespan are not honored
  // this prevents multiple quick triggers from always queing up a throttled refresh
  debouncedOktaRefresh = debounce(
    () => this.throttledOktaRefresh(),
    (this.config.rateLimiting.debounceRequestSeconds * 1000),
    { leading: true, trailing: false, maxWait: (this.config.rateLimiting.debounceRequestSeconds * 1000) });

  // throttle requests to Okta, once per 15 minutes
  // subsequent requests received within this timespan are *queued* to occur once when the timespan has elapsed
  throttledOktaRefresh = throttle(
    () => { this.performOktaRefresh() },
    (this.config.rateLimiting.throttleRequestMinutes * 60) * 1000,
    { leading: true, trailing: false });

  // call Okta by forcing the image to refresh. this can be replaced with an HTTP call w/cookies.
  performOktaRefresh() {
    this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.keepAliveUrl + "?d=" + new Date().getTime());
  }
}